import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { AtMessageModule, FacetListComponent, FormErrorsModule, IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { GenFacetComponent } from './facet/facet.component';

@Component({
  selector: 'gen-facet-list',
  templateUrl: './facet-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    FormErrorsModule,
    ReactiveFormsModule,
    FormsModule,
    KeyboardFocusModule,
    AtMessageModule,
    RouterModule,
    GenFacetComponent,
  ]
})
export class GenFacetListComponent extends FacetListComponent {

}
